<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
      <path
        d="M4.293 4.293a1 1 0 0 1 1.414 0l14 14a1 1 0 0 1-1.414 1.414l-14-14a1 1 0 0 1 0-1.414Z"
      />
      <path
        d="M19.707 4.293a1 1 0 0 1 0 1.414l-14 14a1 1 0 1 1-1.414-1.414l14-14a1 1 0 0 1 1.414 0Z"
      />
    </g>
  </svg>
</template>
